import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
  } from '@angular/common/http';
  import { Injectable, isDevMode } from '@angular/core';
  import { Observable, catchError, finalize, tap, throwError } from 'rxjs';

  @Injectable()
  export class HttpLoggingInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      const requestId = this.generateRequestId();
      const startTime = Date.now();
      let status: 'Success' | 'Error' = 'Success';

      if (isDevMode()) {
        console.info(`HTTP Request ${request.method} ${request.url} initiated`, { requestId });
      }

      return next.handle(request).pipe(
        tap((event) => {
          if (event instanceof HttpResponse && isDevMode()) {
            console.info(`HTTP Response ${request.method} ${request.url}`, {
              requestId,
              status: event.status,
            });
          }
        }),
        catchError((error: HttpErrorResponse) => {
          status = 'Error';
          if (isDevMode()) {
            console.error(`HTTP Request Error ${request.method} ${request.url}`, {
              requestId,
              status: error.status,
              message: error.message,
            });
          }
          return throwError(() => error);
        }),
        finalize(() => {
          const elapsedTime = Date.now() - startTime;
          if (isDevMode()) {
            console.info(`HTTP Request ${request.method} ${request.url} completed`, {
              requestId,
              duration: `${elapsedTime}ms`,
              status,
            });
          }
        })
      );
    }

    private generateRequestId(): string {
      return Math.random().toString(36).substring(2) + Date.now().toString(36);
    }
  }
